import {
	Box,
	Divider,
	Typography,
	List,
	ListItemText,
	ListItem,
	Grid,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import PublishIcon from "@mui/icons-material/Publish";
import dayjs from "dayjs";
import {
	resetAllStates,
	saveCustomerGroup,
	setCGState,
	submitCustomerGroup,
	uploadFileForCustomerGroup,
} from "../customerGroupSetupSlice";
import CollapseSection from "../../../../components/ui/CollapseSection";
import CustomButton from "../../../../components/ui/CustomButton";

export default function CreateSummary() {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;

	const isRestrictedAccess = setAccess;
	const cgState = useSelector((store) => store.customerGroupSetup);
	const {
		createCGName,
		createFromDate,
		createToDate,
		selCustomers,
		countryID,
		country,
		createComments,
		customerTypeCode,
		customerLevelID,
		files,
	} = cgState;
	const dispatch = useDispatch();

	function getDateFromDayjsDate(date, exactTime) {
		// console.log("CGCreate_getDateFromDayjsDate_InputDate", date);
		let outputDate = null;
		if (date && date instanceof dayjs) {
			const year = date.year();
			const month = date.month() + 1;
			const day = date.date();
			const time = new Date();

			if (exactTime) {
				const formattedTime = time.toLocaleTimeString("en-US", {
					hour12: false,
					hour: "2-digit",
					minute: "2-digit",
					second: "2-digit",
				});
				outputDate = `${year}-${month < 10 ? "0" + month : month}-${
					day < 10 ? "0" + day : day
				}T${formattedTime}`;
			} else {
				outputDate = `${year}-${month < 10 ? "0" + month : month}-${
					day < 10 ? "0" + day : day
				}T00:00:00`;
			}
		} else if (date && typeof date === "string") {
			outputDate = date;
		}
		// console.log("CGCreate_getDateFromDayjsDate_OutputDate", outputDate);
		return outputDate;
	}

	function formatCustomersDate() {
		const updatedCustomers = selCustomers.map((item) => {
			if (
				item.hasOwnProperty("effectiveStartDate") &&
				item.hasOwnProperty("effectiveEndDate")
			) {
				return item;
			}
			return {
				...item,
				effectiveStartDate: createFromDate,
				effectiveEndDate: createToDate,
			};
		});
		dispatch(setCGState("selCustomers", updatedCustomers));
		const customerList = updatedCustomers.map((item) => {
			return {
				...item,
				effectiveStartDate: getDateFromDayjsDate(
					item.effectiveStartDate,
					false
				),
				effectiveEndDate: getDateFromDayjsDate(item.effectiveEndDate, false),
			};
		});
		return customerList;
	}

	function getCustomerGroupFiles() {
		const groupFiles = files.map((item) => {
			return {
				customerGroupFileID: 0,
				customerGroupID: 0,
				filePath: item.name,
				fileType: item.type,
			};
		});
		return groupFiles;
	}

	function validateDates() {
    // debugger
    if (!dayjs(createFromDate).isValid()) {
      showMessage(
				"Invalid date given.",
				"error"
			);
			return false;
    }
		const today = dayjs().startOf("day"); // Get today's date without time
		const fromDate = dayjs(createFromDate);

		if (fromDate.isBefore(today)) {
			showMessage(
				"The 'From Date' cannot be in the past. Please select a valid date.",
				"error"
			);
			return false;
		}
		return true;
	}

	function submitCG() {
		if (!validateDates()) {
			return;
		}
		if (createCGName.length <= 0) {
			showMessage("Please enter a valid customer group name ", "error");
			return;
		}
		const data = JSON.parse(localStorage.getItem("data"));
		const createdCG = {
			customerlist: formatCustomersDate(),
			customerGroupFiles: getCustomerGroupFiles(),
			selectedCustomerID: [],
			FilePaths: [],
			countryID,
			customerGroupName: createCGName,
			comments: createComments,
			updatedBy: data.email,
			email: data.email,
			effectiveStartDate: getDateFromDayjsDate(createFromDate, false),
			effectiveEndDate: getDateFromDayjsDate(createToDate, false),
			updatedDate: dayjs().toISOString(),
			customerGroupTypeCode: customerTypeCode,
			customerGroupLevelCode: customerLevelID,
			customerGroupID: 0,
			sentToSAP: "N",
			status: "Submitted",
			previousGroupID: 0,
			sapGrpCode: "",
			activeInScenarios: 0,
		};
		console.log(createdCG);

		const fileData = new FormData();
		files.forEach((file, index) => {
			if (file instanceof File) {
				fileData.append("files", file);
			}
		});

		dispatch(uploadFileForCustomerGroup(fileData));
		//dispatch(submitCustomerGroup(createdCG));
		//dispatch(resetAllStates({ edit: true }));

		dispatch(submitCustomerGroup(createdCG)).then((action) => {
			if (submitCustomerGroup.fulfilled.match(action)) {
				setTimeout(() => {
					dispatch(resetAllStates({ edit: true }));
				}, 1500);
			}
		});
	}

	function showMessage(message, severity) {
		dispatch(setCGState("popUpMsg", message));
		dispatch(setCGState("popUpSeverity", severity));
		dispatch(setCGState("popUpOpen", true));
	}

	function saveCG() {
		if (!validateDates()) {
			return;
		}
		if (createCGName.length <= 0) {
			showMessage("Please enter a valid customer group name ", "error");
			return;
		}
		const data = JSON.parse(localStorage.getItem("data"));
		const createdCG = {
			customerlist: formatCustomersDate(),
			customerGroupFiles: getCustomerGroupFiles(),
			selectedCustomerID: [],
			FilePaths: [],
			countryID,
			customerGroupName: createCGName,
			comments: createComments,
			updatedBy: data.email,
			email: data.email,
			effectiveStartDate: getDateFromDayjsDate(createFromDate, false),
			effectiveEndDate: getDateFromDayjsDate(createToDate, false),
			updatedDate: dayjs().toISOString(),
			customerGroupTypeCode: customerTypeCode,
			customerGroupLevelCode: customerLevelID,
			customerGroupID: 0,
			sentToSAP: "N",
			status: "Draft",
			previousGroupID: 0,
			sapGrpCode: "",
			activeInScenarios: 0,
		};
		console.log(createdCG);

		const fileData = new FormData();
		files.forEach((file, index) => {
			if (file instanceof File) {
				fileData.append("files", file);
			}
		});

		dispatch(uploadFileForCustomerGroup(fileData));
		//dispatch(saveCustomerGroup(createdCG));
		//dispatch(resetAllStates({ edit: true }));
		dispatch(saveCustomerGroup(createdCG)).then((action) => {
			if (saveCustomerGroup.fulfilled.match(action)) {
				setTimeout(() => {
					dispatch(resetAllStates({ edit: true }));
				}, 1500);
			}
		});
	}

	return (
		<Box sx={{ mt: 6 }}>
			<CollapseSection title="Summary">
				<Grid container spacing={1} sx={{ mb: 1, mt: 1 }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>
							Customer Group Name:
						</Typography>
					</Grid>
					<Grid item>
						<Typography>{createCGName}</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={1} style={{ marginBottom: "5px" }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>Country:</Typography>
					</Grid>
					<Grid item>
						<Typography>{country}</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={1} style={{ marginBottom: "5px" }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>
							Validity Period:
						</Typography>
					</Grid>
					<Grid item>
						<Typography>
							{new Date(createFromDate)
								.toLocaleDateString("en-UK", {
									year: "numeric",
									month: "2-digit",
									day: "2-digit",
								})
								.replace(/\//g, "-")}
							<strong> to</strong>{" "}
							{new Date(createToDate)
								.toLocaleDateString("en-UK", {
									year: "numeric",
									month: "2-digit",
									day: "2-digit",
								})
								.replace(/\//g, "-")}
						</Typography>
					</Grid>
				</Grid>

				<Typography sx={{ fontWeight: "bold" }}>Customers:</Typography>
				<Box
					sx={{
						width: "100%",
						height: 130,
						border: 1,
						borderRadius: 1,
						overflow: "auto",
						borderColor: "#c6c6c6",
						marginBottom: "10px",
					}}
				>
					<List>
						{selCustomers.map((item, index) => {
							return (
								<ListItem key={index}>
									<ListItemText>{item.customerName}</ListItemText>
								</ListItem>
							);
						})}
					</List>
				</Box>
			</CollapseSection>
			<Divider sx={{ mt: 4 }} />
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-end",
					mt: 2,
				}}
			>
				<CustomButton
					startIcon={<SaveIcon />}
					disabled={!isRestrictedAccess}
					sx={{
						mt: 1,
						mr: 2,
					}}
					onClick={saveCG}
				>
					Save
				</CustomButton>
				<CustomButton
					startIcon={<PublishIcon />}
					disabled={!isRestrictedAccess}
					sx={{
						mt: 1,
					}}
					onClick={submitCG}
				>
					Submit
				</CustomButton>
			</Box>
		</Box>
	);
}
